import {
    CANDIDATE_PRO_IMG_REQUEST,
    CANDIDATE_PRO_IMG_SUCCESS,
    CANDIDATE_PRO_IMG_FAIL,
} from "../constants/AuthConstant";

const initialState = {
    loading: false,
    error: null,
    success: false,
    data: null,
};

const candidateProImgReducer = (state = initialState, action) => {
    switch (action.type) {
        case CANDIDATE_PRO_IMG_REQUEST:
            return {
                ...state,
                loading: action.payload,
            };
        case CANDIDATE_PRO_IMG_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                data: action.result,
                error: null,
            };
        case CANDIDATE_PRO_IMG_FAIL:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.error,
                data: null,
            };
        default:
            return state;
    }
};

export default candidateProImgReducer;
